import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Joins class values and lets a later Tailwind class override an earlier one
// that sets the same property, so a caller's `class` beats a component default.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
